const getAttr = (attributes) => {

  function f(key) {
    return attributes[key]
        ? !!attributes[key].value
            ? attributes[key].value
            : true
        : undefined;
  }

  return f;
};

export default getAttr;
